import i18n from "@/i18n/index";

export const USER_TYPES = [
    {
        value: "ACTIVE",
        label: i18n.t("adminUsersGroups.typeACTIVE")
    },
    {
        value: "INACTIVE",
        label: i18n.t("adminUsersGroups.typeINACTIVE")
    },
    {
        value: "DISABLED",
        label: i18n.t("adminUsersGroups.typeDISABLED")
    }
];

export const USER_STATUS = [
    {
        value: "EXTERNAL",
        label: i18n.t("adminUsersGroups.typeEXTERNAL")
    },
    {
        value: "PLATFORM",
        label: i18n.t("adminUsersGroups.typePLATFORM")
    }
];

export const GROUP_TYPES = [
    {
        value: "EXTERNAL",
        label: i18n.t("adminUsersGroups.typeEXTERNAL")
    },
    {
        value: "PLATFORM",
        label: i18n.t("adminUsersGroups.typePLATFORM")
    },
    {
        value: "SYSTEM",
        label: i18n.t("adminUsersGroups.typeSYSTEM")
    },
    {
        value: "APPLICATION",
        label: i18n.t("adminUsersGroups.optionTypeApp")
    }
];

export const GROUP_STATUS = [
    {
        value: "ACTIVE",
        label: i18n.t("adminUsersGroups.typeACTIVE")
    },
    {
        value: "DISABLED",
        label: i18n.t("adminUsersGroups.typeDISABLED")
    }
];
